/* Local category guide. No tracking, cookies, external calls or chat service. */
(() => {
  const choices = {
    start: {title: 'Erst den Platz klären. Dann das Set.', copy: 'Miss deinen verfügbaren Platz aus und vergleiche danach die Setgrößen. Schau bei jedem Set genau auf den Lieferumfang.', links: [['sets', 'Komplettsets vergleichen'], ['contact', 'Ich brauche Beratung']]},
    upgrade: {title: 'Watt fehlt deinem Setup?', copy: 'Steig direkt beim passenden Bereich ein. Vor dem Kauf bitte Maße, Anschlüsse und die vorhandenen Komponenten abgleichen.', links: [['lights', 'Beleuchtung'], ['air', 'Lüftung & Klima'], ['water', 'Bewässerung']]},
    plants: {title: 'Fang beim Substrat an.', copy: 'Erde, Coco oder Hydro? Danach richtet sich die Auswahl. Anwendung und Dosierung findest du beim jeweiligen Produkt und im Herstellerschema.', links: [['food', 'Dünger entdecken'], ['soil', 'Erde & Substrate'], ['contact', 'Kombination abklären']]}
  };
  class GrowtopiaDiscover extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const reset = event.target.closest('[data-reset]');
        if (reset) {
          this.querySelector('.gt-finder-result').hidden = true;
          this.querySelectorAll('[data-goal]').forEach(b => b.setAttribute('aria-pressed','false'));
          this.querySelector('[data-goal]').focus();
          return;
        }
        const button = event.target.closest('[data-goal]');
        if (!button || !this.contains(button)) return;
        const selection = choices[button.dataset.goal];
        if (!selection) return;
        this.querySelectorAll('[data-goal]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        const title = this.querySelector('[data-result-title]');
        title.textContent = selection.title;
        this.querySelector('[data-result-copy]').textContent = selection.copy;
        const links = this.querySelector('[data-result-links]');
        links.replaceChildren();
        selection.links.forEach(([key,label],index) => {
          const href = this.dataset[key];
          if (!href) return;
          const a = document.createElement('a');
          a.href = href; a.textContent = label;
          a.className = 'gt-button' + (index ? ' gt-button--outline' : '');
          links.append(a);
        });
        this.querySelector('.gt-finder-result').hidden = false;
        title.focus({preventScroll: true});
        title.scrollIntoView({block:'nearest', behavior:'auto'});
      });
    }
  }
  if (!customElements.get('gt-discover')) customElements.define('gt-discover', GrowtopiaDiscover);
})();
